import type CrudAction from '@/features/crud/CrudAction';

import type { RouteRecordRaw } from 'vue-router';

import CrudActionType from '@/features/crud/CrudActionType';

const AffiliateNetworksPage = async () => import('@/pages/AffiliateNetworksPage.vue');

export default function getAffiliateNetworksRoutes(): RouteRecordRaw[] {
  return [
    {
      name: 'affiliate-networks',
      component: AffiliateNetworksPage,
      meta: {
        tabTitle: 'Aff. networks',
        title: 'Affiliate Networks',
        useIn: ['navigation-tabs'],
      },
      path: '/affiliate-networks',
      props: () => ({
        crudAction: null,
      }),
    },
    {
      name: 'create-affiliate-network',
      component: AffiliateNetworksPage,
      path: '/affiliate-networks/create',
      props: (): {
        crudAction: CrudAction;
      } => ({
        crudAction: {
          type: CrudActionType.CREATE,
        },
      }),
    },
    {
      name: 'edit-affiliate-network',
      component: AffiliateNetworksPage,
      path: '/affiliate-networks/edit/:id',
      props: (
        route,
      ): {
        crudAction: CrudAction;
      } => ({
        crudAction: {
          id: route.params.id as string,
          type: CrudActionType.EDIT,
        },
      }),
    },
    {
      name: 'clone-affiliate-network',
      component: AffiliateNetworksPage,
      path: '/affiliate-networks/clone/:id',
      props: (
        route,
      ): {
        crudAction: CrudAction;
      } => ({
        crudAction: {
          id: route.params.id as string,
          type: CrudActionType.CLONE,
        },
      }),
    },
  ];
}
